var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWattAttackLogoSquareDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 600,
    viewBox: "0 0 600 600",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 600,
    rx: 40,
    fill: "#111F28"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m125.63 443-41.4-281.2h68.04l22.84 197.46 23.31-197.46h55.2l23.31 197.46 22.84-197.46h68.52L326.4 443h-77.08l-23.3-142.26L202.7 443h-77.08Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m304.48 443 44.72-281.2h96.59L489.56 443h-73.75l-6.18-46.15h-28.55L375.85 443h-71.37Zm77.07-78.5h28.08l-13.8-147.98-14.27 147.97Z",
    fill: "#FC5900"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWattAttackLogoSquareDark);
export default __webpack_public_path__ + "static/media/WattAttackLogoSquareDark.fbd214eb8c222bd7b5bc97e1cf4666e3.svg";
export { ForwardRef as ReactComponent };